'use strict';

angular.module('AcaApp').controller('QuestionIntegrationController', [
  '$scope',
  '$mdDialog',
  'ShortcutsService',
  'SendService',
  'SURVEY',
  /* jscs:disable maximumLineLength, requireCamelCaseOrUpperCaseIdentifiers */
  function($scope, $mdDialog, ShortcutsService, SendService, SURVEY){
    ShortcutsService.disableBackSpaceDefault();
    $scope.data = {};
    $scope.errorMessage = '';
    $scope.closeModal = function(){
      ShortcutsService.enableBackSpaceDefault();
      $mdDialog.hide();
    };
    $scope.save = function(){
      if($scope.data.option === undefined){
        setErrorMessage(SURVEY.SCALEMANDATORY);
        return;
      }
      else{
        setErrorMessage('');
      }
      var request = {
        score: parseInt($scope.data.option),
        textresponse: $scope.feedback
      };
      SendService.saveNps(request).then(function(){
        $scope.closeModal();
      }, function(error){
        setErrorMessage(error.data.error.frontend_message);
      });
    };
    var setErrorMessage = function(value){
      $scope.errorMessage = value;
    };
  }
]);
